export function getLocalStorageItem(key, prefix) {
  key = prefix ? `${prefix}.${key}` : key;
  return localStorage.getItem(key);
}

export function setLocalStorageItem(key, value, prefix) {
  key = prefix ? `${prefix}.${key}` : key;
  return localStorage.setItem(key, value);
}
